import React, { PropsWithChildren } from 'react';

import { CircularProgress, Box, GridSize } from '@material-ui/core';

import { disableEvent } from 'utils';

import { Card, CardContent, Typography, Grid, Backdrop } from './style';

interface CardComponentProps {
  title?: string | JSX.Element,
  xs?: GridSize,
  sm?: GridSize,
  md?: GridSize,
  lg?: GridSize,
  CardHeaderNav?: React.ComponentType,
  wrapperClassName?: string,
  contentClassName?: string,
  titleClassName?: string,
  loadingText?: string,
  isLoading?: boolean,
  useSpinner?: boolean,
}

export function CardComponent<T,>({
  title = '',
  children,
  xs = 12,
  sm = 8,
  lg,
  md,
  CardHeaderNav,
  wrapperClassName = '',
  contentClassName = '',
  titleClassName = '',
  isLoading = false,
  useSpinner = true,
  loadingText,
}: PropsWithChildren<T & CardComponentProps>) {
  return (
    <Grid item xs={xs} sm={sm} md={md} lg={lg} className={wrapperClassName} onKeyDown={() => disableEvent(isLoading)}>
      <Card>
        {isLoading && (
          <Backdrop open={isLoading}>
            <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center">
              {useSpinner && <CircularProgress size={40} thickness={4} />}
              {loadingText && <Typography className="loadingText">{loadingText}</Typography>}
            </Box>
          </Backdrop>
        )}
        <CardContent className={`titleWrapper ${titleClassName}`}>
          {title && (
            <>
              <Typography variant="h2" gutterBottom>
                {title}
              </Typography>
              {CardHeaderNav && <CardHeaderNav />}
            </>
          )}
        </CardContent>
        <CardContent className={contentClassName}>{children}</CardContent>
      </Card>
    </Grid>
  );
}
